import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3db95734"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Order Book")
const _hoisted_2 = { class: "content-row" }
const _hoisted_3 = { style: {"white-space":"nowrap"} }
const _hoisted_4 = {
  key: 0,
  width: "100%"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Buy"),
  /*#__PURE__*/_createElementVNode("th", null, "Price"),
  /*#__PURE__*/_createElementVNode("th", null, "Sell")
], -1))
const _hoisted_6 = { style: {"text-align":"center"} }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_text, { style: {"font-size":"1.5rem"} }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderBooks, (orderBook, index) => {
        return (_openBlock(), _createBlock(_component_ion_card, {
          style: {},
          key: index
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card_header, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_subtitle, null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Helpers.formatDate(orderBook.periodFrom)) + " - " + _toDisplayString(_ctx.Helpers.formatDate(orderBook.periodTo)), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_ion_card_content, null, {
              default: _withCtx(() => [
                (orderBook.entries.length)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
                      _hoisted_5,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderBook.entries, (entry, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", {
                            style: _normalizeStyle(
                                `text-align: right; background: linear-gradient(to left, green ${_ctx.Helpers.getPercentage(
                                    orderBook.totalBuyQuantity,
                                    entry.buyQuantity
                                )}%, rgb(0, 0, 0, 0.0) 0%)`
                            )
                          }, _toDisplayString(`${_ctx.Helpers.convertToKWH(entry.buyQuantity)} KW/h`), 5),
                          _createElementVNode("td", _hoisted_6, _toDisplayString(entry.price) + " NOK", 1),
                          _createElementVNode("td", {
                            style: _normalizeStyle(
                                `text-align: left; background: linear-gradient(to right, red ${_ctx.Helpers.getPercentage(
                                    orderBook.totalSellQuantity,
                                    entry.sellQuantity
                                )}%, rgb(0, 0, 0, 0.0) 0%)`
                            )
                          }, _toDisplayString(`${_ctx.Helpers.convertToKWH(entry.sellQuantity)} KW/h`), 5)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, "No entries"))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ])
  ], 64))
}